import React from 'react'
import unset from 'lodash.unset'

const ModalsStateContext = React.createContext()
const ModalsDispatchContext = React.createContext()

export const useModalsState = () => React.useContext(ModalsStateContext)

export const useModalsDispatch = () => React.useContext(ModalsDispatchContext)

export const useModals = () => [useModalsState(), useModalsDispatch()]

const ModalsContext = ({ children }) => {
  const [modals, setModals] = React.useState({})

  const open = ({ name, data }) => {
    setModals((prevModals) => {
      if (prevModals[name]) {
        console.error(`Modal with name ${name} already exists`)
        return prevModals
      }

      return {
        ...prevModals,
        [name]: data || {}
      }
    })
  }

  const close = ({ name }) => {
    setModals((prevModals) => unset(prevModals, name))
  }

  const modalsDispatch = React.useMemo(() => ({ open, close }), [])

  return (
    <ModalsStateContext.Provider value={modals}>
      <ModalsDispatchContext.Provider value={modalsDispatch}>
        {children}
      </ModalsDispatchContext.Provider>
    </ModalsStateContext.Provider>
  )
}

export default ModalsContext
